import React, { useState } from "react";
import "./Contact.scss";
import LazyLoad from "react-lazyload";
import { FormattedMessage } from "react-intl";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";
import "swiper/scss";
import "swiper/css/navigation";
// import "swiper/modules/pagination/pagination.min.css";

function Contact({ setChatbotHeight, currentLocale }) {
  const [chatbot, setChatbot] = useState(null);

  return (
    <section id="contact">
      <h2>
        <FormattedMessage id="home.contact.h" />
      </h2>
      <div className="wrapper">
        <div className={`member member1`}>
          <div className="photo-wrapper">
            <div className="text">
              <p className="name">
                <FormattedMessage id="home.contact.name1" />
              </p>
              <p>
                <FormattedMessage id="home.contact.job1" />
              </p>
            </div>
            <LazyLoad className="photo" offset={800} once>
              <img src="images/contact/photo-pavel.png" alt="" />
            </LazyLoad>
          </div>
          <div className="bubble">
            <FormattedMessage id="home.contact.question1" />
          </div>
          <div onClick={() => setChatbot("pavel")} className="answer">
            <FormattedMessage id="home.contact.answer1" />
          </div>
        </div>
        <div className={`member member2`}>
          <div className="photo-wrapper">
            <div className="text">
              <p className="name">
                <FormattedMessage id="home.contact.name2" />
              </p>
              <p>
                <FormattedMessage id="home.contact.job2" />
              </p>
            </div>
            <LazyLoad className="photo" offset={800} once>
              <img src="images/contact/photo-tomas.png" alt="" />
            </LazyLoad>
          </div>
          <div className="bubble">
            <FormattedMessage id="home.contact.question2" />
          </div>
          <div onClick={() => setChatbot("tomas")} className="answer">
            <FormattedMessage id="home.contact.answer2" />
          </div>
        </div>
        <div className={`member member3`}>
          <div className="photo-wrapper">
            <div className="text">
              <p className="name">
                <FormattedMessage id="home.contact.name3" />
              </p>
              <p>
                <FormattedMessage id="home.contact.job3" />
              </p>
            </div>
            <LazyLoad className="photo" offset={800} once>
              <img src="images/contact/photo-barbora.png" alt="" />
            </LazyLoad>
          </div>
          <div className="bubble">
            <FormattedMessage id="home.contact.question3" />
          </div>
          <div onClick={() => setChatbot("barbora")} className="answer">
            <FormattedMessage id="home.contact.answer3" />
          </div>
        </div>
        <div className={`member member4`}>
          <div className="photo-wrapper">
            <div className="text">
              <p className="name">
                <FormattedMessage id="home.contact.name4" />
              </p>
              <p>
                <FormattedMessage id="home.contact.job4" />
              </p>
            </div>
            <LazyLoad className="photo" offset={800} once>
              <img src="images/contact/photo-filip.png" alt="" />
            </LazyLoad>
          </div>
          <div className="bubble">
            <FormattedMessage id="home.contact.question4" />
          </div>
          <div onClick={() => setChatbot("filip")} className="answer">
            <FormattedMessage id="home.contact.answer4" />
          </div>
        </div>
      </div>
      <Swiper
        slidesPerView={1}
        spaceBetween={30}
        loop={true}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Pagination, Navigation]}
        className="mySwiper swiper"
        initialSlide={2}
      >
        <SwiperSlide className={`member member1`}>
          <div className="photo-wrapper">
            <div className="text">
              <p className="name">
                <FormattedMessage id="home.contact.name1" />
              </p>
              <p>
                <FormattedMessage id="home.contact.job1" />
              </p>
            </div>
            <LazyLoad className="photo" offset={800} once>
              <img src="images/contact/photo-pavel.png" alt="" />
            </LazyLoad>
          </div>
          <div className="bubble">
            <FormattedMessage id="home.contact.question1" />
          </div>
          <div onClick={() => setChatbot("pavel")} className="answer">
            <FormattedMessage id="home.contact.answer1" />
          </div>
        </SwiperSlide>
        <SwiperSlide className={`member member2`}>
          <div className="photo-wrapper">
            <div className="text">
              <p className="name">
                <FormattedMessage id="home.contact.name2" />
              </p>
              <p>
                <FormattedMessage id="home.contact.job2" />
              </p>
            </div>
            <LazyLoad className="photo" offset={800} once>
              <img src="images/contact/photo-tomas.png" alt="" />
            </LazyLoad>
          </div>
          <div className="bubble">
            <FormattedMessage id="home.contact.question2" />
          </div>
          <div onClick={() => setChatbot("tomas")} className="answer">
            <FormattedMessage id="home.contact.answer2" />
          </div>
        </SwiperSlide>
        <SwiperSlide className={`member member3`}>
          <div className="photo-wrapper">
            <div className="text">
              <p className="name">
                <FormattedMessage id="home.contact.name3" />
              </p>
              <p>
                <FormattedMessage id="home.contact.job3" />
              </p>
            </div>
            <LazyLoad className="photo" offset={800} once>
              <img src="images/contact/photo-barbora.png" alt="" />
            </LazyLoad>
          </div>
          <div className="bubble">
            <FormattedMessage id="home.contact.question3" />
          </div>
          <div onClick={() => setChatbot("barbora")} className="answer">
            <FormattedMessage id="home.contact.answer3" />
          </div>
        </SwiperSlide>
        <SwiperSlide className={`member member4`}>
          <div className="photo-wrapper">
            <div className="text">
              <p className="name">
                <FormattedMessage id="home.contact.name4" />
              </p>
              <p>
                <FormattedMessage id="home.contact.job4" />
              </p>
            </div>
            <LazyLoad className="photo" offset={800} once>
              <img src="images/contact/photo-filip.png" alt="" />
            </LazyLoad>
          </div>
          <div className="bubble">
            <FormattedMessage id="home.contact.question4" />
          </div>
          <div onClick={() => setChatbot("filip")} className="answer">
            <FormattedMessage id="home.contact.answer4" />
          </div>
        </SwiperSlide>
      </Swiper>
      {chatbot === "pavel" && (
        <>
          <iframe
            id="chatbot3"
            onLoad={() => setChatbotHeight("chatbot3")}
            onClick={() => setChatbotHeight("chatbot3")}
            className="chatbot"
            src={`./chatbots/${currentLocale}/pavel.html`}
            frameborder="0"
          ></iframe>
        </>
      )}
      {chatbot === "tomas" && (
        <>
          <iframe
            id="chatbot4"
            onLoad={() => setChatbotHeight("chatbot4")}
            onClick={() => setChatbotHeight("chatbot4")}
            className="chatbot"
            src={`./chatbots/${currentLocale}/tomas.html`}
            frameborder="0"
          ></iframe>
        </>
      )}
      {chatbot === "barbora" && (
        <>
          <iframe
            id="chatbot5"
            onLoad={() => setChatbotHeight("chatbot5")}
            onClick={() => setChatbotHeight("chatbot5")}
            className="chatbot"
            src={`./chatbots/${currentLocale}/barbora.html`}
            frameborder="0"
          ></iframe>
        </>
      )}
      {chatbot === "filip" && (
        <>
          <iframe
            id="chatbot6"
            onLoad={() => setChatbotHeight("chatbot6")}
            onClick={() => setChatbotHeight("chatbot6")}
            className="chatbot"
            src={`./chatbots/${currentLocale}/filip.html`}
            frameborder="0"
          ></iframe>
        </>
      )}
    </section>
  );
}

export default Contact;
